module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"cancel-label":"Cancelar","confirmation-ok-label":"Sim","confirmation-cancel-label":"Não","confirmation-title":"Confirmação","ok-label":"Confirmar","skip":"Pular"}}')
  delete Component.options._Ctor
}
